import {
  app_default
} from "./chunk-VOGPL3W7.mjs";
import {
  DEFAULT_THEME
} from "./chunk-5UTBCMBA.mjs";

// src/theme-provider/ThemeProvider.tsx
import { useContext } from "react";
import {
  ThemeProvider as EmotionThemeProvider,
  ThemeContext as EmotionThemeContext
} from "@emotion/react";
import { jsx, jsxs } from "react/jsx-runtime";
var ThemeProvider = (props) => {
  const { children, theme = DEFAULT_THEME } = props;
  return /* @__PURE__ */ jsxs(EmotionThemeProvider, { theme, children: [
    children,
    /* @__PURE__ */ jsx(app_default, { ...theme })
  ] });
};
var useTheme = () => {
  const context = useContext(
    EmotionThemeContext
  );
  if (!context)
    throw new Error("useTheme must be used within ThemeProvider");
  return context;
};

export {
  ThemeProvider,
  useTheme
};
